const ProgressHeader = ({ currentStep, totalSteps, stepName, nextStepHint }) => {
  return (
    <div className="bg-[#f6f7f8] rounded-xl p-4 -mx-6 -mt-6 mb-6">
      <div className="flex gap-6 justify-between items-center mb-3">
        <div className="flex items-center gap-2">
          <span className="flex items-center justify-center bg-primary text-white rounded-full size-6 text-xs font-bold">
            {currentStep}
          </span>
          <p className="text-[#111418] text-base font-bold">
            {stepName}
          </p>
        </div>
        <p className="text-gray-500 text-sm">Step {currentStep} of {totalSteps}</p>
      </div>
      <div className="rounded-full bg-gray-200 h-2">
        <div
          className="h-2 rounded-full bg-primary transition-all duration-300"
          style={{ width: `${(currentStep / totalSteps) * 100}%` }}
        ></div>
      </div>
      <div className="flex items-center gap-2 text-gray-500 mt-3">
        <span className="material-symbols-outlined text-sm">arrow_forward</span>
        <p className="text-sm">{nextStepHint}</p>
      </div>
    </div>
  )
}

export default ProgressHeader
